import { SnackbarProps, SnackbarStatus } from '@weareopenr/component-library';
import { boldMenuName } from 'src/helpers/truncateMenuName/boldMenuName';

export const successNotification = (
  timetableName: string,
  channelNames: string[],
  scheduleTime: string,
): SnackbarProps => ({
  status: SnackbarStatus.SUCCESS,
  message: (
    <>
      You have successfully {scheduleTime ? 'scheduled' : 'published'} {boldMenuName(timetableName)} to{' '}
      {channelNames.join(', ')}
    </>
  ),
});

export const errorNotification = (timetableName: string, scheduleTime: string, error?: string): SnackbarProps => ({
  status: SnackbarStatus.ERROR,
  message: error || (
    <>
      Something went wrong whilst {scheduleTime ? 'scheduling' : 'publishing'} {boldMenuName(timetableName)}
    </>
  ),
});
